import { Error404View } from '@collab/organisms';
import LoginHelp from '@collab/pages/LoginHelp';
import { environment } from '@collab/utils/environment';

import { designSupportEmail } from 'config/config';
import useLogin from 'libs/users/useLogin';
import useLogout from 'libs/users/useLogout';

const LoginHelpPage = () => {
  const login = useLogin();
  const logout = useLogout();

  return (
    <LoginHelp
      websiteName="Design Portal"
      supportEmail={designSupportEmail}
      login={login}
      logout={logout}
    />
  );
};

LoginHelpPage.pageMods = LoginHelp.pageMods;

export default environment.DESIGN_LOGIN
  ? () => <Error404View />
  : LoginHelpPage;
